<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12 xs12>
            <v-card>
              <v-toolbar dense flat>
                <v-toolbar-title>Configurasi Sidang</v-toolbar-title>
                <v-spacer/>
                <v-btn color="pink" dark small @click="setConfig()" :disabled="configdisabled">set config</v-btn>
                <v-btn color="blue" dark small :loading="importLoading" @click="importData()">import data</v-btn>
              </v-toolbar>
              <v-card-text>
                <v-progress-linear :indeterminate="true" class="ma-0" v-if="tingkatLoading"></v-progress-linear>
                <v-btn-toggle v-model="toggle_tingkat" mandatory class="mr-3" dark>                
                  <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                </v-btn-toggle>                
                <v-slider
                  v-model="bpm"
                  color="blue"
                  always-dirty
                  min="1"
                  max="9"
                  style="max-width:400px"
                >
                  <template v-slot:prepend>
                    <v-icon
                      color="teal"
                      @click="decrement"
                    >
                      remove_circle
                    </v-icon>
                  </template>

                  <template v-slot:append>
                    <v-icon
                      color="cyan"
                      @click="increment"
                    >
                      add_circle
                    </v-icon>
                  </template>
                </v-slider>   
                <h3>Step Sidang : {{bpm}}</h3>             
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 lg12>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <template v-for="(step, i) in bpm">
                  <v-stepper-step :key="'s'+i" :complete="e1 > step" :step="step" @click="e1=step">step {{step}}</v-stepper-step>
                  <v-divider :key="'d'+i" v-if="i < (bpm-1)"></v-divider>  
                </template>                                
              </v-stepper-header>

              <v-stepper-items>
                <template v-for="(step, i) in bpm">
                
                  <v-stepper-content :key="i" :step="step" class="pa-0">
                    <v-card class="mt-1" v-if="fm[i]">
                      <v-card-actions class="pa-3">
                        <v-btn icon dark color="blue-grey" @click="readData(step)" :loading="fm[i].loading"><v-icon>opacity</v-icon></v-btn>
                        <span class="ml-2">Total Ceklis : <strong>{{totalCeklis.true}}</strong> </span> &nbsp; |
                        <span class="ml-2">Sisa : <strong>{{totalCeklis.false}}</strong></span>
                        <v-spacer/>
                        <v-btn color="cyan" dark :loading="fm[i].loading" @click="simpanData(step)">Save</v-btn>
                        <v-btn color="primary" dark @click="e1 = e1+1">Continue</v-btn>
                      </v-card-actions>
                      <v-divider />
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12 md1>
                            <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                              <v-btn small flat class="red white--text" :value="1">L</v-btn>
                              <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                            </v-btn-toggle>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-autocomplete                
                              box
                              v-model="fm[i].parameter"
                              :items="parameters"
                              label="Select Parameter"
                              multiple item-value="id"
                              item-text="name"                                  
                              hide-details
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md4 v-if="fm[i].parameter.includes(5)">
                            <v-autocomplete                
                              box
                              v-model="fm[i].wawancara"
                              :items="quetionnaires"
                              label="Select Pertanyaan"
                              multiple 
                              item-value="no"
                              item-text="question"                                  
                              hide-details
                            >
                              <template v-slot:selection="{ item, selected }">
                                <span>{{item.no}}. {{item.question}}</span>                                
                              </template>
                              <template v-slot:item="{ item }">                                
                                <span>{{item.no}}. {{item.question?item.question.substring(0,100):''}}</span>                                
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md1>
                            <v-text-field box label="max Yes" type="number" @input="setYes($event, i)" hide-details></v-text-field>
                          </v-flex>
                          <v-flex xs6 md1>
                            <v-btn color="success" small :loading="fm[i].excelLoading" class="ma-0" dark @click="export2excel(step)">
                              <v-icon left>select_all</v-icon> .xls
                            </v-btn> 
                          </v-flex>
                          <v-flex xs6 md2>
                            <v-switch class="mt-0" v-model="showCadangan" label="setcadangan?" hide-details />
                            <v-switch class="mt-0" v-model="showJurusan" label="setjurusanke2?" hide-details v-if="toggle_tingkat >= 3" />
                          </v-flex>                          
                        </v-layout>                        
                      </v-card-text>
                      <v-progress-linear :indeterminate="true" class="ma-0" v-if="fm[i].loading"></v-progress-linear>
                      <v-card-text class="v-table__overflow pa-0">                        
                        <table class="tb-normal" :id="'journal'+step">
                          <thead>
                            <tr>
                              <th rowspan="2" class="sticky-col first-col">Rank</th>
                              <th rowspan="2" @click="sortData(i)" class="indigo--text sticky-col second-col" style="cursor:pointer">Nama</th>
                              <th rowspan="2" @click="sortData(i,'yes')" class="indigo--text sticky-col third-col" style="cursor:pointer">Yes</th>
                              <th v-if="showCadangan" rowspan="2" @click="sortData(i,'cadangan')" class="indigo--text sticky-col fourth-col" style="cursor:pointer">Cadangan</th>
                              <th v-if="showJurusan" rowspan="2" @click="sortData(i,'jurusan')" class="indigo--text sticky-col fourth-col" style="cursor:pointer">KeJurusan</th>
                              <th rowspan="2">No Ujian</th>
                              <template v-if="fm[i].parameter.includes(7)">
                                <th rowspan="2">Tempat, Tgl Lahir</th>
                                <th rowspan="2">Sekolah Asal</th>
                                <th rowspan="2">Nama Ayah</th>
                                <th rowspan="2">Pekerjaan Ayah</th>
                                <th rowspan="2">Penghasilan Ayah</th>
                                <th rowspan="2">Nama Ibu</th>
                                <th rowspan="2">Pekerjaan Ibu</th>
                                <th rowspan="2">Penghasilan Ibu</th>
                                <th rowspan="2">Pengeluaran</th>
                                <th rowspan="2">Telepon</th>
                                <th rowspan="2">Whatsapp</th>
                                <th rowspan="2">Alamat</th>
                                <th rowspan="2">Kelurahan</th>
                                <th rowspan="2">Kecamatan</th>
                                <th rowspan="2">Kab/Kota</th>
                                <th rowspan="2">provinsi</th>
                              </template>
                              <template v-if="fm[i].parameter.includes(8)">
                                <th rowspan="2" @click="sortData(i,'jalur')" class="indigo--text">Jalur</th>
                              </template>
                              <th v-if="fm[i].parameter.includes(6)">Prestasi</th>                              
                              <th colspan="3" v-if="fm[i].parameter.includes(1)" @click="sortData(i, 1)" class="indigo--text" style="cursor:pointer">Nilai Quran</th>
                              <template v-if="fm[i].parameter.includes(2)">
                                <th rowspan="2" @click="sortData(i, 2, 'hadir')" class="indigo--text" style="cursor:pointer">Kehadiran</th>
                                <th rowspan="2" @click="sortData(i, 2, 'date')" class="indigo--text" style="cursor:pointer">Tanggal</th>
                                <template v-for="(rapor, j) in ujians" >
                                  <th :key="'rkl'+j" :colspan="2" @click="sortData(i, 2, j)" class="indigo--text" style="cursor:pointer">
                                    {{rapor.name}} <br/><small>[soal:{{rapor.childs?rapor.childs.soal_jumlah:'-'}}, kkm:{{rapor.childs.soal_kkm}}]</small>
                                  </th>                        
                                </template>
                                <th rowspan="2" @click="sortData(i, 2, 'rata')" class="indigo--text" style="cursor:pointer">RATA NILAI</th>
                              </template>
                              <template v-if="fm[i].parameter.includes(3)">
                                <template v-for="(rapor, j) in rapors" >
                                  <th :key="'jhr'+j" :colspan="Array.isArray(rapor.childs)?(rapor.childs.length+1):0" @click="sortData(i, 3, j)" class="indigo--text" style="cursor:pointer">
                                    {{rapor.name}}
                                  </th>                        
                                </template>
                              </template>
                              <template v-if="fm[i].parameter.includes(5)">
                                <th :colspan="fm[i].wawancara.length">Wawancara</th>
                              </template>
                            </tr>
                            <tr>
                              <template v-if="fm[i].parameter.includes(1)">
                                <th>1</th>
                                <th>2</th>
                                <th>status</th>
                              </template> 
                              <template v-if="fm[i].parameter.includes(2)">                                
                                <template v-for="(rapor, j) in ujians">
                                  <th :key="'.'+j">Benar</th>
                                  <th :key="'lr'+j">Nilai</th>                        
                                </template>  
                              </template>  
                              <template v-if="fm[i].parameter.includes(3)">
                                <template v-for="(rapor, j) in rapors">
                                  <template v-for="(child, k) in rapor.childs">
                                    <th :key="j+'.'+k">{{child.name}}</th>
                                    <th :key="j+'ri'+k" v-if="k == (rapor.childs.length-1)">rata2</th>
                                  </template>                    
                                </template>
                              </template>    
                              <template v-if="fm[i].parameter.includes(5)">
                                <th v-for="(no, i) in fm[i].wawancara" :key="i">Pertanyaan {{no}}</th>
                              </template>                       
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(c, j) in fm[i].items">
                              <tr :key="j">
                                <td class="sticky-col first-col">{{c.ranking = c.ranking ? c.ranking : (j+1)}}</td>
                                <td class="sticky-col second-col">{{c.calon.nama}} ({{c.calon.gender ==1 ?'L':'P'}})</td>
                                <td class="sticky-col third-col text-xs-center">
                                  <v-checkbox v-model="c.status" :true-value="1" hide-details class="mt-0 pt-0" hide-details
                                    :label="getLabelJurusan(c.calon)">
                                  </v-checkbox>                                  
                                </td>
                                <td class="sticky-col fourth-col text-xs-center" v-if="showCadangan">
                                  <select v-model="c.cadangan" v-if="c.status != 1" @change="c.jurusan = null">
                                    <option :value="null">--------</option>
                                    <option value="1">Cadangan</option>
                                    <option value="-1">Tidak Lulus</option>                                    
                                  </select>                                                                    
                                </td>
                                <td class="sticky-col fourth-col text-xs-center" v-if="showJurusan">                                  
                                  <select v-model="c.jurusan" v-if="c.status != 1 && c.cadangan">
                                    <option value="0" v-if="c.jurusan == 0">-pilih jurusan-</option>
                                    <option :value="null">-pindah jurusan-</option>
                                    <option value="4" v-if="c.calon.jurusan_id!=4">IPA</option>
                                    <option value="5" v-if="c.calon.jurusan_id!=5">IPS</option>
                                    <option value="6" v-if="c.calon.jurusan_id!=6">AGAMA</option>
                                  </select>                                  
                                </td>
                                <td>{{c.gedung ? c.gedung.number : ''}}</td>
                                <template v-if="fm[i].parameter.includes(7)">
                                  <td>{{c.calon.lahir_tempat}}, {{$moment(c.calon.lahir_tanggal).format('DD/MM/YYYY')}}</td>
                                  <td style="min-width:300px">{{c.calon.sekolah_nama}}, KEC. {{c.calon.sekolah_kecamatan_nama}}, {{c.calon.sekolah_kota_nama}}, {{c.calon.sekolah_provinsi_nama}}</td>                          
                                  <td>{{c.calon.ayah_nama}}</td>
                                  <td>{{c.calon.ayah_pekerjaan}}</td>
                                  <td>{{c.calon.ayah_penghasilan}}</td>
                                  <td>{{c.calon.ibu_nama}}</td>
                                  <td>{{c.calon.ibu_pekerjaan}}</td>
                                  <td>{{c.calon.ibu_penghasilan}}</td>
                                  <td>{{c.calon.pengeluaran}}</td>
                                  <td>{{c.calon.telepon}}</td>
                                  <td>{{c.calon.whatsapp}}</td>
                                  <td>{{c.calon.alamat}}</td>
                                  <td>{{c.calon.kelurahan_nama}}</td>                          
                                  <td>{{c.calon.kecamatan_nama}}</td>
                                  <td>{{c.calon.kota_nama}}</td>                          
                                  <td>{{c.calon.provinsi_nama}}</td>
                                </template>
                                <template v-if="fm[i].parameter.includes(8)">
                                  <td>{{getJalurName(c.calon.jalur_id)}}</td>
                                </template>
                                <td v-if="fm[i].parameter.includes(6)" style="min-width:300px">
                                  <span v-for="(prestasi,i) in c.prestasis" :key="i">{{prestasi.description}}, </span>
                                </td>
                                <template v-if="fm[i].parameter.includes(1)">
                                  <template v-if="c.test">                                    
                                    <td class="text-xs-right">{{c.test.quran1}}</td>
                                    <td class="text-xs-right">{{c.test.quran2}}</td>
                                    <td class="text-xs-left">
                                      <v-chip small dark v-if="c.test.quran==1" color="green">lulus</v-chip>
                                      <v-chip small dark v-else-if="c.test.quran==0" color="yellow">mengulang</v-chip>
                                      <v-chip small dark v-else-if="c.test.quran==-1" color="orange">telah mengulang</v-chip>                                    
                                    </td>
                                  </template>  
                                  <td v-else colspan="3"></td>
                                </template>
                                <template v-if="fm[i].parameter.includes(2)">
                                  <template v-if="c.test">
                                    <td>
                                      <v-chip v-if="c.test.ujian_hadir==1" color="green" small dark label>Hadir</v-chip>
                                      <v-chip v-else color="red" small dark label>Alfa</v-chip>                                      
                                    </td>
                                    <td>{{c.test.ujian_date}}</td>
                                    <template v-if="c.test.ujians && c.test.ujians.length">
                                      <template v-for="(ujian, j) in c.test.ujians">
                                        <td :key="j+'.'" :class="parseInt(ujian.benar) < parseInt(ujians[j].childs.soal_kkm) ? 'red lighten-4 text-xs-center':'text-xs-center'" style="border-color:#ccc!important">
                                         {{ujian.benar}}
                                        </td>
                                        <td :key="j+'r'" style="border-color:#ccc!important" class="text-xs-center yellow lighten-4" >
                                          <template>{{parseFloat(ujian.nilai).toFixed(2)}}</template>
                                        </td>                        
                                      </template>
                                    </template>
                                    <template v-else>
                                      <td :colspan="3*2"></td>
                                    </template>
                                    <td class="text-xs-center cyan lighten-4" style="border-color:#ccc!important">{{c.test.ujian_nilai}} | {{c.lowkkm}}</td>
                                  </template>
                                  <template v-else>
                                    <td :colspan="(ujians.length*2)+3"></td>
                                  </template>                                  
                                </template>
                                <template v-if="fm[i].parameter.includes(3)">
                                  <template v-if="c.test && Array.isArray(c.test.rapors)">
                                    <template v-for="(rapor, j) in c.test.rapors">
                                      <template v-for="(child, k) in rapor.childs">
                                        <td :key="j+'.'+k">
                                          <input type="number" @input="setData(item)" v-model="child.nilai" style="padding:5px; max-width:45px" />
                                        </td>
                                        <td :key="j+'r'+k" v-if="k == (rapor.childs.length-1)" style="border-color:#ccc!important" class="text-xs-center yellow lighten-4">
                                          {{parseFloat(rapor.nilai).toFixed(2)}}
                                        </td>
                                      </template>                    
                                    </template>
                                  </template>
                                  <template v-else>
                                    <template v-for="(rapor, j) in rapors">
                                      <template v-for="(child, k) in rapor.childs">
                                        <td :key="j+'.'+k"></td>
                                        <td :key="j+'rio'+k" v-if="k == (rapor.childs.length-1)" style="border-color:#ccc!important" class="text-xs-center yellow lighten-4"></td>
                                      </template>                    
                                    </template>
                                  </template>
                                </template>
                                <template v-if="fm[i].parameter.includes(5)">
                                  <template v-if="Array.isArray(c.quetionnaire)">
                                    <template v-for="(no, j) in fm[i].wawancara">
                                      <td :key="j" valign="top" v-if="c.quetionnaire.find(x=>x.no==no)" :set="item=c.quetionnaire.find(x=>x.no==no)">
                                        <span v-if="item.type == 1">{{item.option.find(x=>x.id==item.answer_id)?item.option.find(x=>x.id==item.answer_id).value:''}}</span>
                                        <span v-if="item.type == 2">                          
                                          <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                            {{item.option.find(x=>x.id==ans)?item.option.find(x=>x.id==ans).value:''}},
                                          </span>
                                        </span>
                                        <span v-if="item.type == 3">
                                          <span v-for="(ans, k) in item.answer_jsonvalue" :key="k" v-if="ans">
                                            {{ans}},
                                          </span>
                                        </span>  
                                      </td>
                                      <td v-else></td>
                                    </template>
                                  </template>
                                  <template v-else>
                                    <td :colspan="fm[i].wawancara.length"></td>
                                  </template>                                  
                                </template>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </v-card-text>
                      <v-card-actions class="pa-3">
                        <v-spacer/>
                        <v-btn color="cyan" :loading="fm[i].loading" dark @click="simpanData(step)">Save</v-btn>
                        <v-btn color="primary" dark @click="e1 = e1+1">Continue</v-btn>
                      </v-card-actions>
                    </v-card>                    
                  </v-stepper-content>

                </template>                
              </v-stepper-items>
            </v-stepper>
          </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Table2Excel from 'table2excel.js';
import { debounce } from 'lodash'
import model from '@/apps/admin/models/Sidang';   

export default {
  data: () => ({
    e1:null,
    bpm:1, showCadangan : false, showJurusan:false,
    tingkats : [], tingkatLoading : false,
    toggle_tingkat : 2,
    toggle_gender : [1,2],
    importLoading : false,
    fm : [
      { items : [], parameter:[1,2], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
      { items : [], parameter:[], wawancara:[], excelLoading : false, loading : false, },
    ],
    parameters:[
      {id:1,name:'nilai_quran'},
      {id:2,name:'ujian_tulis'},
      {id:3,name:'nilai_raport'},
      //{id:4,name:'angket'},
      {id:5,name:'quetionnaire'},
      {id:6,name:'prestasi'},
      {id:7,name:'profile'},
      {id:8,name:'jalur'},
    ],
    ujians:[], rapors:[], quetionnaires:[],
    configdisabled:false,
  }),  
  watch:{
    toggle_tingkat(newTingkat){
      for(var i =0; i<this.bpm; i++){
        if(this.fm[i]){
          this.fm[i].items = [];
        }        
      }
      model.step({tingkat_id:newTingkat}).then(data=>{
        this.bpm = parseInt(data.value);        
      });
      model.settings({key:'ujian_'+newTingkat}).then(data=>{  
        if(Array.isArray(data.value)){
          this.ujians = data.value;             
        }                  
      });
      this.configdisabled = false;
      if(newTingkat<3){
        this.showJurusan = false;
      }
    },
    bpm:debounce(function(newbpm){ 
      this.configdisabled = false;     
      for(var i =0; i<newbpm; i++){
        if(!this.fm[i]){
          this.fm[i] = {items :[], parameter:[], excelLoading : false, loading : false};
        }        
      }    
      model.maxStep({tingkat_id:this.toggle_tingkat}).then(data=>{
        this.e1 = isNaN(parseInt(data))? 1 : parseInt(data);        
      });
      //model.saveStep({step:newbpm},{tingkat_id:this.toggle_tingkat});
    },1000),  
    toggle_gender:debounce(function(newGender){
      this.readData(this.e1);
    }, 1000)   
  },
  computed:{
    totalCeklis(){      
      let i = this.e1;
      if(this.fm[i-1]){
        let obj = _.countBy(this.fm[i-1].items, function (rec) { 
          return rec.status == true;
        });
        return obj;
      }  
      return {};
    }
  },
  mounted(){ 
    this.tingkatLoading = true;
    model.tingkats().then(data=>{this.tingkats=data;this.tingkatLoading = false;});        
    model.step({tingkat_id:this.toggle_tingkat}).then(data=>{
      this.bpm = parseInt(data.value);      
    });
    model.settings({key:'ujian_'+this.toggle_tingkat}).then(data=>{  
      if(Array.isArray(data.value)){                  
        this.ujians = data.value;             
      }  
    });  
    model.settings({key:'rapor_'+this.toggle_tingkat}).then(data=>{            
      if(Array.isArray(data.value)){        
        this.rapors = data.value; 
      }
    });      
    model.quetionnaires({jilid_id:1}).then(data=>{
      if(Array.isArray(data)){        
        this.quetionnaires = data;
      }
    });
  },            
  methods: {
    setConfig(){
      model.saveStep({step:this.bpm},{tingkat_id:this.toggle_tingkat}).then(res=>{
        if(res.status==200){
          this.bpm = parseInt(res.data.value);
          this.configdisabled = true;
        }
      });
    },

    setYes : debounce(function(e, i){
      this.fm[i].items.forEach((item,i)=>{
        if(i<e){
          item.status = 1;
        } else {
          item.status = 0;
        }       
      })
    }, 600),      
    decrement () {
      this.bpm--
    },
    increment () {
      this.bpm++
    },
    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
    },
    importData(){
      this.$swal({title: 'Are you sure to import to step 1?', text: "You won't be able to revert this!",  type: 'warning',showCancelButton: true, confirmButtonColor: '#FFAA00', cancelButtonColor: '#2AAAFF', confirmButtonText: 'Yes, import it!'}).then((result) => {                 
        if (result.value) { 
          this.importLoading = true;
          model.import({tingkat_id:this.toggle_tingkat}).then(res=>{            
            this.importLoading = false;
          });
        }
      });  
    },
    readData(i){
      console.log('sini',i);
      if(this.fm[i-1]){
        this.fm[i-1].loading = true;
        this.fm[i-1].items = [];
        model.index({tingkat_id:this.toggle_tingkat, step:i, jilid_id:1, gender:this.toggle_gender,
          expand:'calon,test,prestasis,quetionnaire,gedung'
        }).then(res=>{        
          this.fm[i-1].items = res.data;
          this.fm[i-1].loading = false;

          this.fm[i-1].items.forEach((item,i)=>{
            item.lowkkm = 0;
            if(item.test && Array.isArray(item.test.ujians)){
              item.test.ujians.forEach((uji,j)=>{
                if(parseInt(uji.benar) < parseInt(this.ujians[j].childs.soal_kkm)){
                  item.lowkkm += 1;
                }
              });                
            } else {
              item.lowkkm = 9;
            }
          })
        })
      }      
    },
    simpanData(i){
      if(this.fm[i-1]){
        this.fm[i-1].loading = true;
        let datasend = [];               
        this.fm[i-1].items.forEach(item=>{          
          let status = item.status; 
          if(item.cadangan == 1 || item.jurusan > 3){
            status = 2;
          }
          datasend.push({step:i, tingkat_id:this.toggle_tingkat, calon_id:item.calon_id, status:status, cadangan:item.cadangan, jurusan:item.jurusan, ranking:item.ranking});
        })
        model.simpan({data:datasend},{tingkat_id:this.toggle_tingkat, step:i,
          expand:'calon,test,prestasis,quetionnaire,gedung'
        }).then(res=>{
          this.readData(i);
        })
      }
    },
    getLabelJurusan(calon){
      if(calon.tingkat_id >=3){
        switch(calon.jurusan_id){
          case 4 : return 'IPA';
          case 5 : return 'IPS';
          case 6 : return 'AGAMA';
          default : return ;
        }
      }
    },
    sortData(i, parameter=0, code=''){
      if(this.fm[i]){
        switch(parameter){
          case 'yes':
            this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.status||''}], ['desc']);
            break;
          case 'jalur':
            this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.calon.jalur_id||''}], ['desc']);
            break;
          case 'cadangan':
            this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.cadangan||''}], ['desc']);
            break;
          case 'jurusan':
            this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.cadangan||''}], ['asc']);
            break;  
          case 0:
            this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.calon.nama||''}], ['asc']);
            break;
          case 1: 
            this.fm[i].items = _.orderBy(this.fm[i].items,  [( o ) => { return o.test ? o.test.quran1 || '' : ''},( o ) => { return o.test ? o.test.quran2 || '' : ''}, (o)=>{return o.test?o.test.quran||'':''}], ['desc','desc','desc']);
            break;
          case 2:            
            switch(code){
              case 'hadir':
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test?o.test.ujian_hadir||'':''}], ['desc']);
                break;
              case 'date':
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test?o.test.ujian_date||'':''}], ['desc']);
                break;  
              case 'rata':
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test?o.test.ujian_hadir||'':''},(o)=>{return o.lowkkm||''}, (o)=>{return o.test?o.test.ujian_nilai||'':''}], ['desc','asc','desc']);
                break;  
              case 0:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.ujians) && o.test.ujians[0]?parseInt(o.test.ujians[0].benar)||'':''}], ['desc']);
                break;    
              case 1:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.ujians) && o.test.ujians[1]?parseInt(o.test.ujians[1].benar)||'':''}], ['desc']);
                break;     
              case 2:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.ujians) && o.test.ujians[2]?parseInt(o.test.ujians[2].benar)||'':''}], ['desc']);
                break;
              case 3:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.ujians) && o.test.ujians[3]?parseInt(o.test.ujians[3].benar)||'':''}], ['desc']);
                break;     
            }
            break;  
          case 3:
            switch(code){
              case 0:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.rapors) && o.test.rapors[0]?parseInt(o.test.rapors[0].nilai)||'':''}], ['desc']);
                break;    
              case 1:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.rapors) && o.test.rapors[1]?parseInt(o.test.rapors[1].nilai)||'':''}], ['desc']);
                break;     
              case 2:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.rapors) && o.test.rapors[2]?parseInt(o.test.rapors[2].nilai)||'':''}], ['desc']);
                break;
              case 3:
                this.fm[i].items = _.orderBy(this.fm[i].items,  [(o)=>{return o.test && Array.isArray(o.test.rapors) && o.test.rapors[3]?parseInt(o.test.rapors[3].nilai)||'':''}], ['desc']);
                break;     
            }
            break;  
        }        
        this.fm[i].items.forEach((item,i)=>{item.ranking = (i+1);})
      }
    },
    export2excel(i){
      if(this.fm[i-1]){
        this.fm[i-1].excelLoading = true;
        setTimeout(()=>{
          if(this.fm[i-1].items.length > 0){
            var filename = 'Rekap.';            
            filename    += this.$moment().format('DDMMYY.HHmm');
            new Table2Excel('#journal'+i).export(filename);
          } else {
            window.getApp.$emit('showSnackbar', {
                show : true,
                text : 'No Data Result',
                color: 'orange'
            });
          }
          this.fm[i-1].excelLoading = false;
        }, 200);
      }
    },

    getJalurName(jalur_id){
      switch(parseInt(jalur_id)){
        case 1 : return 'Reguler'; break;
        case 2 : return 'Prestasi'; break;
        case 3 : return 'Internal'; break;
        case 4 : return 'Undangan'; break;
        default : return jalur_id; break;  
      }
    }
  }
}
</script>
<style>
.v-radio label{font-size:13px}  
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 1px 6px;
}
.v-chip .v-chip__content {
    
    z-index: 0;
}
.sticky-col {
  position: sticky;
  position: -webkit-sticky;    
  background-color: #eeefff;
  border: 1px solid #000;
  z-index:1;
}

.first-col {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  left: 0px; 
}

.second-col {
  width: 200px;
  min-width: 200px;
  max-width: 2000px;
  left: 50px;
}

.third-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  left: 250px; 
}
.fourth-col {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  left: 350px; 
}
.fifth-col {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  left: 450px; 
}

</style>